import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadGatewaysList } from '../../redux/gateways/actions';
import Gateways from './Gateways';
import { getGatewaysList } from '../../redux/gateways/selectors';

const ConnectedGatewaysContent = () => {
  const dispatch = useDispatch();
  const { loadingState, data } = useSelector(getGatewaysList);

  useEffect(() => {
    dispatch(loadGatewaysList());
  }, [dispatch]);

  const reloadAction = ({
    serialNumber = null,
    configured = null,
    organizationName = null,
    connection = null,
    limit = undefined,
    page = undefined,
    order = undefined,
    sort = undefined
  } = {}) =>
    dispatch(
      loadGatewaysList(
        serialNumber,
        configured,
        organizationName,
        connection,
        limit,
        page,
        order,
        sort
      )
    );

  return <Gateways loadingState={loadingState} reloadAction={reloadAction} gateways={data} />;
};

export default ConnectedGatewaysContent;
